import useSessionStorage from '@/composables/storage/useSessionStorage';

const { checkSessionStorage, bindSessionStorage } = useSessionStorage();

const feeDataDefaults = {
  networkFee: 0,
  gatewayFee: 0,
  receivedRate: 0,
  quoteValue: 0,
  spread: 0,
};

const storageKey = (storeId) => `${storeId}FeeData`;

/**
 * Quoted fees for an order store, kept in sessionStorage so they survive a reload.
 * `isLoading` is never persisted: it always starts as `true`.
 */
export default function useFeeDataStorage() {
  const restoreFeeData = (storeId) => {
    // eslint-disable-next-line no-unused-vars
    const { isLoading, ...persisted } = checkSessionStorage(storageKey(storeId), {});
    return {
      ...feeDataDefaults,
      ...persisted,
      isLoading: true,
    };
  };

  const persistFeeData = (storeId, feeData) => {
    // eslint-disable-next-line no-unused-vars
    const { isLoading, ...fees } = feeData;
    bindSessionStorage(storageKey(storeId), fees);
  };

  return {
    restoreFeeData,
    persistFeeData,
  };
}
